import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

import CarrierBondTypeSelectField from "./CarrierBondTypeSelectField";

export default function CarrierCommissionDialogs({ vm }) {
  const {
    handleCloseUpdateCommissionDialog,
    commissionEffectiveDate,
    openUpdateCommissionDialog,
    commissionDetailsLoading,
    setOpenCommissionDialog,
    isSubmittingCommission,
    setCommissionPercentage,
    setCommissionEffectiveDate,
    commissionPercentage,
    openCommissionDialog,
    handleUpdateCommission,
    handleAddCommission,
    commissionBondType,
    bondsList,
    commissionData,
    setCommissionBondType,
    commissionPercent,
    setCommissionPercent,
    effectiveDate,
    setEffectiveDate,
    setBondType,
    bondType,
    isSubmitting,
  } = vm;

  return (
    <>
      <Dialog open={openCommissionDialog} onClose={() => setOpenCommissionDialog(false)}>
        <DialogTitle>Add New Commission</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <CarrierBondTypeSelectField
            bondsList={bondsList}
            value={commissionBondType}
            onChange={(e) => setCommissionBondType(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Percentage"
            type="number"
            fullWidth
            variant="outlined"
            value={commissionPercentage}
            onChange={(e) => setCommissionPercentage(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Effective Date"
            type="date"
            fullWidth
            variant="outlined"
            value={commissionEffectiveDate}
            onChange={(e) => setCommissionEffectiveDate(e.target.value)}
            slotProps={{ inputLabel: {
              shrink: true,
            }}}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCommissionDialog(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleAddCommission}
            color="primary"
            variant="contained"
            disabled={isSubmittingCommission}
          >
            {isSubmittingCommission ? <CircularProgress size={24} /> : "Add Commission"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openUpdateCommissionDialog} onClose={handleCloseUpdateCommissionDialog}>
        <DialogTitle>Update Commission</DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          {commissionDetailsLoading ? (
            <CircularProgress />
          ) : (
            <>
              <CarrierBondTypeSelectField
                bondsList={bondsList}
                value={bondType || commissionData.bond_type_display.id}
                onChange={(e) => setBondType(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Commission Percentage"
                type="number"
                fullWidth
                variant="outlined"
                value={commissionPercent !== null ? commissionPercent : commissionData.commission_percent}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || (!Number.isNaN(Number(value)) && Number(value) >= 0)) {
                    setCommissionPercent(value);
                  }
                }}
                slotProps={{ input: {
                  inputProps: { min: 0 },
                }}}
              />
              <TextField
                margin="dense"
                label="Effective Date"
                type="date"
                fullWidth
                variant="outlined"
                value={effectiveDate || commissionData.effective_date}
                onChange={(e) => setEffectiveDate(e.target.value)}
                slotProps={{ inputLabel: {
                  shrink: true,
                }}}
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUpdateCommissionDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleUpdateCommission}
            color="primary"
            variant="contained"
            disabled={isSubmitting}
            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

CarrierCommissionDialogs.propTypes = {
  vm: PropTypes.object.isRequired,
};
